import { showToast } from '../../collections/CollectionUI.js';
import { ErrorHandler } from '../utils/error-handler.js';

/**
 * Execute a batch operation across multiple collections.
 *
 * @param {('make_public'|'make_private'|'duplicate'|'delete')} action - Operation key.
 * @param {number[]} collectionIds - Collection identifiers to mutate.
 * @returns {Promise<void>}
 */
export async function handleBulkAction(action, collectionIds) {
    if (!collectionIds || collectionIds.length === 0) return;

    const progressElement = document.getElementById('bulk-operation-progress');
    const progressText = document.getElementById('bulk-operation-text');
    const progressCounter = document.getElementById('bulk-operation-progress-text');

    progressElement?.classList.remove('hidden');
    if (progressText) {
        const actionText = {
            'make_public': 'Đang đặt công khai...',
            'make_private': 'Đang đặt riêng tư...',
            'duplicate': 'Đang nhân bản...',
            'delete': 'Đang xóa...'
        };
        progressText.textContent = actionText[action] || 'Đang xử lý...';
    }

    let completed = 0;
    const total = collectionIds.length;

    try {
        for (const id of collectionIds) {
            if (progressCounter) {
                progressCounter.textContent = `(${completed + 1}/${total})`;
            }

            switch (action) {
                case 'make_public':
                    await this.api.toggleVisibility(id, true);
                    break;
                case 'make_private':
                    await this.api.toggleVisibility(id, false);
                    break;
                case 'duplicate':
                    await this.api.duplicateCollection(id);
                    break;
                case 'delete':
                    await this.api.deleteCollection(id);
                    break;
            }

            completed++;
        }

        const actionMessages = {
            'make_public': `Đã đặt ${completed} collections thành công khai`,
            'make_private': `Đã đặt ${completed} collections thành riêng tư`,
            'duplicate': `Đã nhân bản ${completed} collections`,
            'delete': `Đã xóa ${completed} collections`
        };

        showToast('success', actionMessages[action] || `Hoàn thành ${completed} thao tác`);

        this.loadCollections();
        if (typeof this.clearBulkSelection === 'function') {
            this.clearBulkSelection();
        }
    } catch (error) {
        const message = ErrorHandler.extractMessage(error);
        ErrorHandler.handle(error, `Lỗi xảy ra sau ${completed}/${total} thao tác: ${message}`);
    } finally {
        progressElement?.classList.add('hidden');
    }
}
